<template>
  <div>
    <section class="page-hero" :style="{ '--ph-img': `url(${images.hero1})` }">
      <div class="wrap">
        <p class="eyebrow reveal">Our Craft</p>
        <h1 class="reveal">From Craftsmanship to Complete Interiors</h1>
        <p class="reveal">A boutique interior design studio with a workshop heart, designing spaces that feel honest, warm and lived-in.</p>
        <p class="crumb reveal"><router-link to="/">Home</router-link> · About</p>
      </div>
    </section>

    <!-- Heritage: where the EIKA name comes from -->
    <section class="section tint">
      <div class="wrap split split-flip">
        <div class="split-figure reveal">
          <img :src="workshopImage" alt="The EIKA workshop, stacked with timber boards and joinery in progress" />
        </div>
        <div class="reveal">
          <p class="eyebrow">Since {{ foundedYear }}</p>
          <h2>From craftsmanship to complete interiors</h2>
          <p>
            Established in {{ foundedYear }}, EIKA Furniture Design and Construction began with a
            foundation in furniture craftsmanship, woodworking and construction. Over the years,
            that foundation has grown into a deeper understanding of how spaces are made — from
            the precision of custom carpentry and furniture to the practical realities of
            construction and installation.
          </p>
          <p>
            Today, EIKA Interiors builds upon this heritage to provide a more complete
            design-and-build experience. We bring together interior design, space planning,
            material selection, carpentry and project coordination under one approach.
          </p>
          <p class="muted">
            With decades of hands-on experience behind the EIKA name, our philosophy remains
            simple: good design should not only look right, but be built right. We believe every
            interior deserves thoughtful planning, honest detailing and craftsmanship that stands
            the test of time.
          </p>
          <div class="split-sign">
            <strong>EIKA Interiors</strong>
            <span>Designing with purpose. Building with experience.</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Intro split -->
    <!-- <section class="section">
      <div class="wrap split">
        <div class="split-figure reveal">
          <img :src="images.heroGathering" alt="A family gathered in a Singapore home designed by EIKA Interiors" />
        </div>
        <div class="reveal">
          <p class="eyebrow">Who we are</p>
          <h2>A studio rooted in craftsmanship</h2>
          <p>
            EIKA was founded on the belief that exceptional homes begin with thoughtful
            practical decisions. While our roots in craftsmanship give us a deep appreciation
            for how things are made, today our focus is helping homeowners navigate every stage
            of their renovation with clarity, care, and purpose.
          </p>
          <p class="muted">
            Design, project management, and craftsmanship come together to create homes that are
            not only beautiful, but built to last.
          </p>
        </div>
      </div>
    </section> -->

    <!-- Values -->
    <section class="section tint">
      <div class="wrap">
        <div class="section-head reveal">
          <p class="eyebrow">What guides us</p>
          <h2>Principles we build by</h2>
        </div>
        <div class="cards">
          <div v-for="v in values" :key="v.title" class="card reveal">
            <span class="card-num">{{ v.phase }}</span>
            <h3>{{ v.title }}</h3>
            <p>{{ v.blurb }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Stats band -->
    <section class="section">
      <div class="wrap">
        <div class="stats reveal">
          <div v-for="s in stats" :key="s.label">
            <strong>{{ s.value }}</strong>
            <p>{{ s.label }}</p>
          </div>
        </div>
      </div>
    </section>

    

    <section class="band" :style="{ '--band-img': `url(${images.livingHallWhite})` }">
      <div class="wrap reveal">
        <blockquote>Good design is quiet. Great design is felt.</blockquote>
        <cite>EIKA Interiors</cite>
      </div>
    </section>

    <section class="section tint">
      <div class="wrap" style="text-align: center">
        <div class="reveal">
          <p class="eyebrow">Say hello</p>
          <h2 style="font-size: clamp(2rem, 4vw, 3.2rem); margin: 1rem 0 1.4rem">Let's craft something that lasts.</h2>
          <router-link to="/contact" class="btn btn-primary">Start a project</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { images } from "@/data/projects";
import { foundedYear, yearsInBusiness } from "@/data/contact";
import workshopImage from "@/assets/eikaworkshop.jpeg";

export default {
  name: "AboutView",
  data() {
    return {
      images,
      workshopImage,
      foundedYear,
      
      values: [
        { phase: "BEFORE", title: "Distinct Interiors", blurb: "We get it. Angles that don't look like anywhere else online, so you can always recognise your own space." },
        { phase: "CURRENT", title: "Considered Spaces", blurb: "Light, flow and proportion planned around how you truly live, day to day." },
        { phase: "FUTURE", title: "Made to Last", blurb: "We plan ahead, from futureproofing your space to selecting the ideal materials." },
      ],
      // Only verifiable numbers belong here. Don't add project counts or awards
      // unless EIKA has confirmed them.
      stats: [
        { value: `${yearsInBusiness}`, label: "Years in business" },
        { value: "4.9★", label: "Rated on Google" },
      ],
    };
  },
};
</script>
